import { render, staticRenderFns } from "./cardType.vue?vue&type=template&id=c1a3386e&"
import script from "./cardType.vue?vue&type=script&lang=js&"
export * from "./cardType.vue?vue&type=script&lang=js&"
import style0 from "./cardType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports